/**
 * @file 各種APIの呼び出し完了状態を管理するステート
 *
 * トップページでは複数のAPIを並行して呼び出すが、
 * 各APIの取得完了を個別にトラッキングすることで、
 * 画面の各セクションが独立してロード完了を判定できる。
 * true = まだ取得完了していない（ロード中）、false = 取得完了済み。
 */
import { atom } from 'recoil';

/** 各APIの呼び出し完了状態を示す型 */
export type ApiStatusStateType = {
  caution: boolean; // 注意事項情報
  customer: boolean; // 顧客情報取得
  user: boolean; // ユーザー情報
  autoNotification: boolean; // 自動通知情報
  payment: boolean; // 支払情報
  options: boolean; // オプション情報
  billing: boolean; //  請求情報
  agreement: boolean; // 工事承諾情報
  fvnoProvide: boolean; // FVNO提供形態
  campaigin: boolean; // キャンペーン情報
  rlsRefundList: boolean; // 返還一覧情報
};

export const apiStatusState = atom<ApiStatusStateType>({
  key: 'apiStatusState',
  default: {
    caution: true,
    customer: false,
    autoNotification: true,
    user: false,
    payment: true,
    options: true,
    billing: true,
    agreement: true,
    fvnoProvide: true,
    campaigin: true,
    rlsRefundList: true,
  },
});

export default apiStatusState;
